const CITIES_TABLE_READY = "cities-table-ready"
const SEARCH_TEXT_STATE = "cities-table-search-text-state"
const ROWS_PER_PAGE_STATE = "cities-table-rows-per-page-state"
const PAGINATION_STATE = "cities-table-pagination-state"

const CITY_ID_FOR_ACTION = "cities-table-city-id-for-action"


const initialState = {
    isCitiesTableReady: true,
    cities: {},

    
    citySelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case CITIES_TABLE_READY:
            return Object.assign({}, state, { isCitiesTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case CITY_ID_FOR_ACTION:
            return Object.assign({}, state, {citySelectedId:action.payload})

        default:
        return state
    
    }

}

export function cityTableReady(data) {
    return {
        type: CITIES_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function cityIdForAction(cityId){
    return{
        type:CITY_ID_FOR_ACTION,
        payload:cityId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Cities/redux/cities.js